import { z } from "zod";

export const FeatureTypeSchema = z.enum(["BOOLEAN", "LIMIT", "STRING"]);
export type FeatureType = z.infer<typeof FeatureTypeSchema>;

export const FeatureFlagSchema = z.object({
  key: z.string().min(1),
  description: z.string().optional(),
  type: FeatureTypeSchema,
  defaultValue: z.string(),
  isGlobal: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});

export type FeatureFlag = z.infer<typeof FeatureFlagSchema>;

export const TenantFeatureSchema = z.object({
  tenantId: z.string(),
  featureKey: z.string(),
  value: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
});

export type TenantFeature = z.infer<typeof TenantFeatureSchema>;
